import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Backup automático numa pasta do aparelho (SAF, Android-only). Oportunístico: roda ao
 * abrir o app. A cadência é FIXA em diária (`BACKUP_INTERVAL_DAYS` em `lib/autoBackup`) —
 * mesma decisão do Drive, não é mais preferência do usuário.
 */
interface AutoBackupState {
    /** Backup automático ligado (recurso Pro). */
    enabled: boolean;
    /** content:// da pasta SAF escolhida pelo usuário (Drive/Files). */
    folderUri: string | null;
    /** Nome amigável da pasta (último segmento, só pra exibir). */
    folderLabel: string | null;
    /** Quantas versões manter na pasta (rotação). */
    keepVersions: number;
    lastBackupAt: string | null;
    setEnabled: (enabled: boolean) => void;
    setFolder: (uri: string | null, label: string | null) => void;
    markBackedUp: (at?: string) => void;
    reset: () => void;
}

const DEFAULTS = {
    enabled: false,
    folderUri: null as string | null,
    folderLabel: null as string | null,
    keepVersions: 5,
    lastBackupAt: null as string | null,
};

export const useAutoBackupStore = create<AutoBackupState>()(
    persist(
        (set) => ({
            ...DEFAULTS,
            setEnabled: (enabled) => set({ enabled }),
            setFolder: (folderUri, folderLabel) => set({ folderUri, folderLabel }),
            markBackedUp: (at) => set({ lastBackupAt: at ?? new Date().toISOString() }),
            reset: () => set(DEFAULTS),
        }),
        {
            name: '@finapp_auto_backup',
            storage: createJSONStorage(() => AsyncStorage),
        },
    ),
);

export async function hydrateAutoBackupStore(): Promise<void> {
    try {
        if (useAutoBackupStore.persist.hasHydrated()) return;
        await useAutoBackupStore.persist.rehydrate();
    } catch {
        // Mantém os defaults se o AsyncStorage falhar.
    }
}
